var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"className":"title"}},[_c('span',[_vm._v(_vm._s(_vm.titleName))]),_c('div',{attrs:{"className":"dashed"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }